import type { User } from 'firebase/auth';

/**
 * Extremely small admin gate.
 *
 * NOTE: This is *client-side* gating (UI activation). If we need hard security,
 * the backend must verify a Firebase ID token.
 */
export const ADMIN_EMAIL = 'nymilitarypolice@gmail.com';

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.trim().toLowerCase() === ADMIN_EMAIL;
}

export function isAdminUser(user: User | null | undefined): boolean {
  return isAdminEmail(user?.email);
}
